module.exports = __webpack_public_path__ + "img/duzhou.a48c4694.jpg";